import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

interface QuizBreadcrumbProps {
  platformName: string;
}

export const QuizBreadcrumb = ({ platformName }: QuizBreadcrumbProps) => {
  return (
    <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-8">
      <Link 
        to="/quizzes/" 
        onClick={() => window.scrollTo(0, 0)}
        className="hover:text-primary transition-colors"
      >
        Quizzes
      </Link>
      <ChevronRight className="w-4 h-4" />
      <span className="text-foreground font-medium">CSW vs {platformName}</span>
    </nav>
  );
};
